import React, { useContext } from "react";
import { FlagsProvider } from "react-feature-flags";
import { CODE_APP, LIKUMI_APP } from "./constants";

// Export in ordrder to use the helpers out of react tree i.e. in config of Proposal
// component which is rendered out of main app context
const isCode = process.env.REACT_APP_SITE_TYPE === CODE_APP;
const isLikumi = process.env.REACT_APP_SITE_TYPE === LIKUMI_APP;

// Available feature toggles
export enum features {
  DISPLAY_CODE_CONTENT = "DISPLAY_CODE_CONTENT",
  DISPLAY_LIKUMI_CONTENT = "DISPLAY_LIKUMI_CONTENT",
  ALLOW_ONLY_ONE_USER_PER_TEAM = "ALLOW_ONLY_ONE_USER_PER_TEAM",
}

// https://www.typescriptlang.org/docs/handbook/2/template-literal-types.html
type FeatureKeys = `${features}`;
interface Flag {
  name: FeatureKeys;
  isActive: boolean;
}

export type FeatureMap = Record<FeatureKeys, boolean>;

// ENV defined options
const flags: Array<Flag> = [
  { name: features.DISPLAY_CODE_CONTENT, isActive: isCode },
  { name: features.DISPLAY_LIKUMI_CONTENT, isActive: isLikumi },
];

// Context to be used with useFlags custom hook
const FeatureContext = React.createContext<FeatureMap>({} as FeatureMap);

// Merges redux auth flags into env defined flags
export const FeatureProvider = ({ children }) => {
  const featureContextFlags: FeatureMap = flags.reduce((acc, curr) => {
    acc[curr.name] = curr.isActive;
    return acc;
  }, {} as FeatureMap);

  return (
    <FlagsProvider value={flags}>
      <FeatureContext.Provider value={featureContextFlags}>
        {children}
      </FeatureContext.Provider>
    </FlagsProvider>
  );
};

export const useFlags = (): FeatureMap => {
  return useContext(FeatureContext);
};
